<template>
  <div class="list-loading__wrap" v-if="visible">
    <div class="loading-image__wrap">
      <img class="loading-image" src="../assets/imgs/loader.gif" alt="Sisley Paris" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ListLoading",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  created() {},
  watch: {
    // visible() {}
  }
}
</script>

<style lang="scss" scoped>
  .list-loading__wrap {
    box-sizing: border-box;
    .loading-image__wrap {
      width: 100px; margin: 0 auto;
    }
  }
  @media screen and (min-width: 48em) {
    .list-loading__wrap {
      .loading-image__wrap {
        width: 150px;
      }
    }
  }
</style>